import React, { useEffect, useState } from 'react'
import { Table, TableBody, TableCell, TableHead, TableRow, IconButton,TablePagination } from '@mui/material';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { getUserActivityDetails } from '../../Helper/userActivityApi';
import UserActivityDetails from './UserActivityDetails';
import SideBar from '../../SideBar';

const UserActivity = () => {

    const [userActivityDetails, setUserActivityDetails] = useState([]);
    const [openUserActivity, setOpenUserActivity] = useState(false);
    const [userDetailsData, setUserDetailsData] = useState('');
    const [page, setPage] = useState(0); // State to track the current page
    const [rowsPerPage, setRowsPerPage] = useState(10);

    // const data = {
    //     firstName: "Hilda Kahia"
    // }

    useEffect(() => {
        async function fetchUserActivityDetails() {
            const response = await getUserActivityDetails();
            setUserActivityDetails(response?.data.body);
            console.log(response);
        }
        fetchUserActivityDetails();
    }, []);

    const openUserDetailsModal = (data) => {
        setOpenUserActivity(true);
        setUserDetailsData(data);
    }

    const handleClosePdfModal = () => {
        setOpenUserActivity(false);
    };
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10)); // Parse the value to an integer
        setPage(0); // Reset to the first page when changing rows per page
    };

    return (
        <div style={({ height: "100vh", display: "flex" })}>
            <SideBar></SideBar>
        <div className='container-fluid p-0 overflow-x-none'>
            <div className='row'>
                <main className='col-lg-12'>
                    <div className='container'>
                        <div className='row margin-left'>
                            <div className='col-12 service-header-font' style={{ color: "#3860B2" }}>
                                User Activity
                            </div>
                            <div className='col-12'>
                            <TableContainer 
                                        component={Paper} 
                                        className='mt-3'
                                        sx={{ maxHeight: '60vh' }} // Set max height for scrolling
                                    >
                                {/* <TableContainer component={Paper} className='mt-3'> */}
                                    <Table size="medium" aria-label="user activity table">
                                    <TableHead style={{ position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#fff' }}>
                                            <TableRow>
                                                <TableCell align="center">ID</TableCell>
                                                <TableCell align="center">User Name</TableCell>
                                                <TableCell align="center">Role</TableCell>
                                                <TableCell align="center">Logins Count</TableCell>
                                                <TableCell align="center">Documents Sent</TableCell>
                                                <TableCell align="center">Documents Exported</TableCell>
                                                <TableCell align="center">Documents Downloaded</TableCell>
                                                <TableCell align="center">Invoices Created</TableCell>
                                                <TableCell align="center">Details</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                        {userActivityDetails?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
                                                   
                                                <TableRow key={row.id}>
                                                    <TableCell align="center">{page * rowsPerPage + index + 1}</TableCell>
                                                    <TableCell align="center">{row?.first_name} {row?.last_name}</TableCell>
                                                    <TableCell align="center">{row?.role_name}</TableCell>
                                                    <TableCell align="center">{row?.login_activity_count}</TableCell>
                                                    <TableCell align="center">{row?.document_sent_count}</TableCell>
                                                    <TableCell align="center">{row?.export_summary_count}</TableCell>
                                                    <TableCell align="center">{row?.file_download_count}</TableCell>
                                                    <TableCell align="center">{row?.invoice_created_count}</TableCell>
                                                    <TableCell align="center">
                                                        <IconButton aria-label="view details" onClick={() => openUserDetailsModal(row)}>
                                                            <VisibilityIcon style={{ color: 'black' }} />
                                                        </IconButton>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <TablePagination
                                        rowsPerPageOptions={[10, 15, 20,25]} // Options for rows per page
                                        component="div"
                                        count={userActivityDetails.length} // Total number of rows
                                        rowsPerPage={rowsPerPage} // Rows to display per page
                                        page={page} // Current page
                                        onPageChange={handleChangePage} // Function to change page
                                        onRowsPerPageChange={handleChangeRowsPerPage} // Function to change rows per page
                                    />
                            </div>
                        </div>
                    </div>
                </main>
                <UserActivityDetails open={openUserActivity} onClose={handleClosePdfModal} userDetailsData={userDetailsData} />
            </div>
        </div>
        </div>
    )
}

export default UserActivity